import {Component, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray, transferArrayItem} from "@angular/cdk/drag-drop";
import {MatCard, MatCardContent, MatCardTitle} from "@angular/material/card";
import {MatError, MatFormField, MatLabel} from "@angular/material/form-field";
import {MatGridList, MatGridTile} from "@angular/material/grid-list";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-user-groups',
  standalone: true,
  imports: [
    CdkDrag, CdkDropList, MatCard, MatCardContent, MatCardTitle, TranslateModule, MatError, MatFormField, MatLabel, MatOption, MatSelect, ReactiveFormsModule, MatGridList, MatGridTile
  ],
  templateUrl: './user-groups.component.html'
})
export class UserGroupsComponent implements OnInit{
  todo = ['SM IT', 'Assistant IT', 'IT Support', 'Assistant IT'];
  done = ['SMS IT', 'Network Administrator'];
  right: string = ">>";
  left: string = "<<";
  usersList: string[] = ["General", "HR"];
  form: FormGroup;
  constructor(private formBuilder: FormBuilder) {
  }
  ngOnInit() {
    this.form = this.formBuilder.group({
      users: ['', [Validators.required]],
    })
  }
  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex,
      );
    }
  }
  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }
  moveRight(){
    // Move all items from todo to done
    this.done.push(...this.todo);
    this.todo = []; // Clear the todo list
  }
  moveLeft(){
    // Move all items from todo to done
    this.todo.push(...this.done);
    this.done = []; // Clear the todo list
  }
}
